import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';

import './index.scss';
import { TextContentComponent } from '@myriadgenetics/mgh-types';

type QualifyBannerProps = {
  type: 'TEXT_CONTENT';
  compDef: TextContentComponent;
  isInOffice?: boolean;
};

export function QualifyBanner(props: QualifyBannerProps) {
  const { t } = useTranslation();
  const inOfficeTitle = 'results.pilot.met.inOfficeTitle';

  if (props.compDef.data.contentKey === 'results.pilot.met.title') {
    return (
      <div role="heading" aria-level={1} className={'qualify-banner qualify-banner__met'}>
        <div className="qualify-banner__met qualify-banner__met__you-qualify">
          <div className="qualify-banner__met icon-wrapper" aria-hidden>
            <FontAwesomeIcon size="lg" icon={faCircleCheck} />
          </div>
          {t(props.compDef.data.contentKey)}
        </div>
        {props.isInOffice && <p className="qualify-banner__met__in-office">{t(inOfficeTitle)}</p>}
      </div>
    );
  } else if (props.compDef.data.contentKey === 'results.pilot.notMet.title') {
    return (
      <div role="heading" aria-level={1} className={'qualify-banner qualify-banner__not-met'}>
        {t(props.compDef.data.contentKey)}
      </div>
    );
  }

  return null;
}

export default QualifyBanner;
